import { type QueryFunctionContext, useInfiniteQuery } from '@tanstack/react-query';
import type { AxiosResponse } from 'axios';
import * as qs from 'qs';

import type { ITableSorting } from '@model/tableSorting';

import { apiClient } from '@services/apiClient';

import type { IEquipmentsList, IUseEquipmentsListKeys } from '../model/equipmentsList';

export const equipmentsListKey = (
  keys: IUseEquipmentsListKeys,
): [string, string, Array<number> | undefined, string, ITableSorting | undefined] => [
  'equipmentsList',
  keys?.searchValue || '',
  keys?.locationIds,
  keys?.equipmentStatusValue || '',
  keys?.sorting,
];

export const equipmentsListFn = ({
  queryKey,
  pageParam = 1,
}: QueryFunctionContext<ReturnType<typeof equipmentsListKey>, number>) => {
  const orderBy = queryKey[4]?.id ? queryKey[4].id : undefined;
  const direction = !queryKey[4]?.id ? undefined : queryKey[4].desc ? 'desc' : 'asc';

  const params = {
    locationIds: queryKey[2],
    pagination: {
      pageSize: 20,
      currentPage: pageParam,
    },
    search: queryKey[1],
    sort: {
      field: orderBy,
      direction: direction,
    },
    ...(queryKey[3] !== 'all' && { active: queryKey[3] === 'active' }),
  };

  return apiClient
    .get(`${APP_API_URL}equipments/list`, {
      params,
      paramsSerializer: {
        serialize: (params) => qs.stringify(params),
      },
    })
    .then(({ data }: AxiosResponse<IEquipmentsList>) => data);
};

export const useEquipmentsListInfiniteQuery = (keys: IUseEquipmentsListKeys) => {
  return useInfiniteQuery({
    queryKey: equipmentsListKey(keys),
    queryFn: equipmentsListFn,
    getNextPageParam: ({ current_page, last_page }) =>
      +current_page < +last_page ? +current_page + 1 : undefined,
    keepPreviousData: true,
    refetchOnWindowFocus: false,
  });
};
